import React, { useContext, useEffect, useRef } from "react";
import { useState } from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import STcontext from "../context/STcontext";
import axios from "../context/axios";
import ThreeDot from "../loading/Three dots/Three_dot";

export default function DetailsModel({ data }) {
   const { NewTask, confirmTask, setErrorsMessages, errorsMessages, isLoading } =
      useContext(STcontext);
   const [show, setShow] = useState(false);
   const [images, setImages] = useState({
      imageUrl: "",
      id: 0,
   });
   const handleClose = () => {
      setShow(false);
      setErrorsMessages(null);
   };

   const filtered = NewTask.Users.filter(
      (user) => user.profil_id === 1 || user.profil_id === 2
   );

   const [UpdateTaskToConfirmed, setUpdateTaskToConfirmed] = useState({
      nomClient: data.nomComplet,
      telephoneClient: data.telephone_client,
      caTache: data.catache,
      date_previsionnelle_debut: data.date_previsionnelle_debut,
      Observation: data.observation,
      ExecutedBy: data.user_name,
      city: data.city_id,
      images: data.images,
   });

   const handleUpdateTaskToConfirmed = (e) => {
      const name = e.target.name;
      const value = e.target.value;
      setUpdateTaskToConfirmed({ ...UpdateTaskToConfirmed, [name]: value });
   };

   const filterCity = {
      ...(NewTask && NewTask.Cities.find((city) => city.id === data.city_id)),
   };

   const showImage = (imageUrl, id) => {
      setImages({ imageUrl, id });
   };

   const closeImageShow = () => {
      setImages({ imageUrl: "", id: 0 });
   };

   const [retation, setRetation] = useState(0);
   const getImage = useRef();

   const retateImage = () => {
      setRetation(retation + 90);
   };


   useEffect(() => {
      // La tâche a été modifiée (ou la liste rafraîchie) : on réinitialise le
      // formulaire pour ne pas afficher d'anciennes valeurs.
      setUpdateTaskToConfirmed({
         nomClient: data.nomComplet,
         telephoneClient: data.telephone_client,
         caTache: data.catache,
         date_previsionnelle_debut: data.date_previsionnelle_debut,
         Observation: data.observation,
         ExecutedBy: data.user_name,
         city: data.city_id,
         images: data.images,
      });
      handleClose();
      // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [data]);

   return (
      <div>
         <Button
            style={{ color: "white", border: "none", margin: "10px" }}
            onClick={() => setShow(true)}
         >
            Confirmer
         </Button>

         <Modal show={show} size="lg" onHide={() => setShow(false)}>
            {images.imageUrl ? (
               <div className="show-image">
                  <div className="close-retation-buttons">
                     <div
                        className="close-retation-button-show-image"
                        aria-label="Close"
                        onClick={retateImage}
                     >
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                           <path d="M48.5 224H40c-13.3 0-24-10.7-24-24V72c0-9.7 5.8-18.5 14.8-22.2s19.3-1.7 26.2 5.2L98.6 96.6c87.6-86.5 228.7-86.2 315.8 1c87.5 87.5 87.5 229.3 0 316.8s-229.3 87.5-316.8 0c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0c62.5 62.5 163.8 62.5 226.3 0s62.5-163.8 0-226.3c-62.2-62.2-162.7-62.5-225.3-1L185 183c6.9 6.9 8.9 17.2 5.2 26.2s-12.5 14.8-22.2 14.8H48.5z" />
                        </svg>
                     </div>
                     <div
                        className="close-retation-button-show-image"
                        aria-label="Close"
                        onClick={closeImageShow}
                     >
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 98 98">
                           <path d="M78.2 23.3L75 20.1 48.7 46.4 22.5 20.1l-3.3 3.2 26.3 26.3-27.2 27.2 3.2 3.3 27.2-27.3L76 80.1l3.2-3.3L52 49.6l26.2-26.3z"></path>
                        </svg>
                     </div>
                  </div>

                  <div
                     style={{
                        width: "100%",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        textAlign: "center",
                     }}
                  >
                     {" "}
                     <img
                        ref={getImage}
                        style={{
                           maxWidth: "50%",
                           width: "auto",
                           transform: `rotate(${retation}deg)`,
                        }}
                        className="d-block"
                        src={`${axios.defaults.baseURL}images/` + images.imageUrl}
                        alt="..."
                     />
                  </div>
                  <div></div>
               </div>
            ) : (
               ""
            )}
            <Modal.Header closeButton>
               <Modal.Title>Détails tâche</Modal.Title>
            </Modal.Header>
            <Modal.Body style={{ gap: "20px", marginBottom: "10px" }}>
               <Form
                  noValidate
                  method="POST"
                  onSubmit={(e) => confirmTask(e, UpdateTaskToConfirmed, data.id)}
               >
                  <Row className="mb-3">
                     <Form.Group as={Col} md="4" controlId="validationCustom01">
                        <Form.Label>Nom client : </Form.Label>
                        <Form.Control
                           required
                           type="text"
                           name="nomClient"
                           onChange={handleUpdateTaskToConfirmed}
                           value={UpdateTaskToConfirmed.nomClient}
                        />
                     </Form.Group>
                     <Form.Group as={Col} md="4" controlId="validationCustom01">
                        <Form.Label>Telephone client : </Form.Label>
                        <Form.Control
                           required
                           type="text"
                           name="telephoneClient"
                           onChange={handleUpdateTaskToConfirmed}
                           value={UpdateTaskToConfirmed.telephoneClient}
                        />
                     </Form.Group>
                     <Form.Group as={Col} md="4" controlId="validationCustom02">
                        <Form.Label>Type du tâche : </Form.Label>
                        <Form.Control
                           type="text"
                           name="caTache"
                           list="dataTask"
                           onChange={handleUpdateTaskToConfirmed}
                           value={UpdateTaskToConfirmed.caTache}
                        />
                        <datalist id="dataTask">
                           {NewTask.TypesTasks.map((TypesTask, index) => (
                              <option key={index}>{TypesTask.catache}</option>
                           ))}
                        </datalist>
                     </Form.Group>
                  </Row>

                  <Row className="mb-3">
                     <Form.Group as={Col} md="4" controlId="validationCustom01">
                        <Form.Label>Exécutée par : </Form.Label>
                        <Form.Control
                           required
                           type="text"
                           name="ExecutedBy"
                           value={
                              UpdateTaskToConfirmed.ExecutedBy
                                 ? UpdateTaskToConfirmed.ExecutedBy
                                 : ""
                           }
                        />
                     </Form.Group>
                     <Form.Group as={Col} md="4" controlId="validationCustom02">
                        <Form.Label>Date previsionnel debut : </Form.Label>
                        <Form.Control
                           type="datetime-local"
                           onChange={handleUpdateTaskToConfirmed}
                           name="date_previsionnelle_debut"
                           value={
                              UpdateTaskToConfirmed.date_previsionnelle_debut
                                 ? UpdateTaskToConfirmed.date_previsionnelle_debut
                                 : ""
                           }
                        />
                     </Form.Group>

                     <Form.Group as={Col} md="4" controlId="">
                        <Form.Label>Affectée à : </Form.Label>
                        <Form.Control
                           list="userList"
                           name="affecte"
                           autoComplete="off"
                           required
                           onChange={handleUpdateTaskToConfirmed}
                        />
                        <datalist id="userList">
                           {filtered
                              ? filtered.map((user, index) => (
                                 <option
                                    key={index}
                                    onChange={() =>
                                       setUpdateTaskToConfirmed({
                                          ...UpdateTaskToConfirmed,
                                          TechnicianID: user.name,
                                       })
                                    }
                                 >
                                    {user.name}
                                 </option>
                              ))
                              : ""}
                        </datalist>
                        <span style={{ color: "red" }}>
                           {errorsMessages && errorsMessages.affecte
                              ? errorsMessages.affecte[0]
                              : ""}
                        </span>
                     </Form.Group>
                  </Row>
                  <Row>
                     <Form.Group as={Col} md="4" controlId="validationCustom01">
                        <Form.Label>réalisée à: </Form.Label>
                        <Form.Select
                           name="city"
                           autoComplete="off"
                           onChange={handleUpdateTaskToConfirmed}
                        >
                           <option selected hidden>
                              {filterCity && filterCity.cityName
                                 ? filterCity.cityName
                                 : "select ville"}
                           </option>
                           {NewTask &&
                              NewTask.Cities.map((city, index) => (
                                 <option key={index} value={city.id}>
                                    {city.cityName}
                                 </option>
                              ))}
                        </Form.Select>
                        <span style={{ color: "red" }}>
                           {errorsMessages && errorsMessages.city
                              ? errorsMessages.city[0]
                              : ""}
                        </span>
                     </Form.Group>
                  </Row>
                  <Row>
                     <Form.Group as={Col} md="12" controlId="validationCustom01">
                        <Form.Label>Observation : </Form.Label>
                        <Form.Control
                           as="textarea"
                           rows={3}
                           type="text"
                           name="Observation"
                           value={
                              UpdateTaskToConfirmed.Observation
                                 ? UpdateTaskToConfirmed.Observation
                                 : ""
                           }
                           onChange={handleUpdateTaskToConfirmed}
                        />
                     </Form.Group>
                  </Row>
                  <Row className="mb-3 imageSlider" md="2">
                     {UpdateTaskToConfirmed.images.length > 0
                        ? UpdateTaskToConfirmed.images.map((imagesTask) => (
                           <div
                              className="images"
                              style={{ maxWidth: "15%" }}
                              key={imagesTask.id}
                           >
                              <img
                                 className="w-100 d-block"
                                 src={
                                    `${axios.defaults.baseURL}images/` +
                                    imagesTask.url_imgtache
                                 }
                                 alt="..."
                                 onClick={() =>
                                    showImage(imagesTask.url_imgtache, imagesTask.id)
                                 }
                                 style={{ aspectRatio: "3/3" }}
                              />
                           </div>
                        ))
                        : "images non disponible"}
                  </Row>
                  <Modal.Footer>
                     <Button type="submit" variant="primary" disabled={isLoading}>
                        {!isLoading ? "Ajouter tâche " : <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "2px" }}>en cours <ThreeDot /></div>}
                     </Button>
                  </Modal.Footer>
               </Form>
            </Modal.Body>
         </Modal>
      </div>
   );
}
